import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import TermsOfUse from "../views/Terms.vue";
import PrivacyPolicy from "../views/Privacy.vue";
import Help from "../views/Help.vue";
import LegalPage from "../views/Legal.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/terms",
    name: "TermsOfUse",
    component: TermsOfUse,
  },
  {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/legal",
    name: "LegalPage",
    component: LegalPage,
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
  },
  {
    path: '/app-ads.txt',
    name: 'AppAdsTxt',
    beforeEnter: () => {
      window.location.href = '/app-ads.txt';
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;